import type { FormEvent } from 'react'

export function formatDatePaymentFormUtil(e: FormEvent<HTMLInputElement>) {
  let { value } = e.currentTarget
  value = value.replace(/(\D)/g, '')

  if (value.length > 3) {
    const result = value.substring(0, 3)
    return result
  }
  return value
}
